<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 194"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <path
            class="fil0 str1"
            d="M73 35l-48 0c0,1 0,22 0,23 0,1 1,1 2,2 0,1 0,2 0,3 0,1 0,3 0,4 0,1 0,2 0,3 0,1 -1,1 -2,2 -1,0 -2,2 -2,3 0,1 3,3 4,4 0,0 1,1 1,2 0,1 0,2 0,3 0,1 0,2 -1,2 -1,1 -4,3 -4,5 0,1 3,2 4,3 0,0 0,1 0,1 0,0 0,1 0,2 0,0 0,1 0,1 0,1 0,1 0,2 0,1 0,1 0,1 -1,2 -4,2 -4,5 0,1 4,3 4,5 0,1 0,3 0,4 0,2 -4,3 -4,5 0,4 4,4 4,9 0,4 -3,4 -3,7 0,3 10,15 14,18l20 0c2,-1 6,-3 8,-5 3,-3 4,-8 4,-12 0,-4 5,-5 5,-8 0,-2 -4,-3 -4,-7 0,-6 4,-6 4,-9 0,-2 -4,-3 -4,-5 0,-1 0,-3 0,-4 0,-2 4,-4 4,-5 0,-3 -3,-3 -4,-5 0,-1 0,-6 0,-7 1,-1 4,-2 4,-3 0,-2 -3,-3 -4,-5 -1,-1 -1,-5 0,-6 1,-1 3,-3 3,-4 0,-1 -4,-4 -5,-5 0,-1 3,-2 3,-3 0,-1 0,-22 0,-23zm-48 102c13,-1 32,-3 47,-7m-46 -8c13,-1 31,-3 46,-6m-45 -8c12,-1 30,-3 45,-6m-44 -8c13,-1 30,-3 44,-6m-45 43c13,-1 31,-3 46,-7m-46 -8c13,-1 32,-3 47,-7m-46 -8c14,-1 32,-3 46,-7m-46 -8c15,-1 32,-3 47,-7m-46 0c13,-1 29,-3 45,-6m-45 -1c13,-1 31,-3 46,-7"
        />
        <path
            class="filWhite str1"
            d="M25 54c-6,2 -12,2 -15,-5 -7,-14 -2,-28 7,-36 6,-6 10,-5 18,-3 6,3 11,4 19,1 7,-4 13,-5 19,-5 12,-1 20,4 21,16 0,13 0,21 -7,30 -2,3 -7,4 -11,2 -1,0 -1,0 -2,-1l0 0c0,0 0,0 -1,0m0 0c-4,-2 -4,-2 -8,-2 -6,0 -11,0 -15,0 -11,0 -18,0 -24,2 0,0 -1,0 -1,1"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
